import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const ChatOption = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='ChatOption' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M9,7 L9,1 L23,1 L23,11 L20,11 L20,16 L15,12 M1,7 L15,7 L15,18 L9,18 L4,22 L4,18 L1,18 L1,7 Z' />
  </StyledIcon>
);
